import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { PlayerForm } from "@/components/family/PlayerForm";
import { athleteQuery, useSaveAthlete } from "@/lib/family";

export const Route = createFileRoute("/_app/players/$athleteId")({
  component: EditPlayerPage,
});

function EditPlayerPage() {
  const { athleteId } = Route.useParams();
  const navigate = useNavigate();
  const save = useSaveAthlete();
  const { data: athlete, isLoading } = useQuery(athleteQuery(athleteId));

  return (
    <section className="mx-auto max-w-xl">
      <Link to="/home" className="text-sm text-white/60 hover:text-white">
        ← Back
      </Link>
      <h1 className="mt-3 font-display text-4xl font-extrabold uppercase italic">Edit player</h1>
      <div className="mt-6">
        {isLoading ? (
          <p className="text-sm text-white/60">Loading…</p>
        ) : !athlete ? (
          <p className="text-sm text-white/70">We couldn't find this player.</p>
        ) : (
          <PlayerForm
            initial={{
              first_name: athlete.first_name,
              last_name: athlete.last_name,
              preferred_name: athlete.preferred_name,
              date_of_birth: athlete.date_of_birth,
              grade: athlete.grade,
              emergency_contact_name: athlete.emergency_contact_name,
              emergency_contact_phone: athlete.emergency_contact_phone,
            }}
            submitLabel="Save changes"
            onSubmit={async (input) => {
              await save.mutateAsync({ id: athleteId, input });
              toast.success("Player updated.");
              navigate({ to: "/home" });
            }}
          />
        )}
      </div>
    </section>
  );
}
